import {
	Disclosure,
	DisclosureContent,
	DisclosureProvider,
} from "@ariakit/react";
import { type ButtonVariants, button, wrap } from "./Collapsible.css";
import type { Props } from "./types";

export default function Collapsible({
	title,
	children,
	open,
	widget,
	onOpen,
	disabled,
	defaultOpen,
}: Props & ButtonVariants) {
	return (
		<div className={wrap({ open })}>
			<DisclosureProvider setOpen={onOpen} defaultOpen={defaultOpen || open}>
				<Disclosure className={button({ widget })} disabled={disabled}>
					{title}
				</Disclosure>
				<DisclosureContent>{children}</DisclosureContent>
			</DisclosureProvider>
		</div>
	);
}
